import * as types from './actionTypes'
import { loasHistoryPagination } from '../../utils/constants'

export const initialState = {
  loads: [],
  hasMore: true,
}

const HistoryLoads = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_HISTORY_LOADS:
      return {
        ...state,
        loads: [
          ...state.loads,
          ...payload,
        ],
        hasMore: payload.length >= loasHistoryPagination,
      }
    case types.CLEAR_HISTORY_LOADS:
      return {
        ...state,
        loads: [],
        hasMore: true,
      }
    case types.SAVE_FILTERS_HISTORY_LOADS:
      return {
        ...state,
        filters: payload,
        hasHistoryFilters: true,
      }
    default:
      return state
  }
}

export default HistoryLoads
